export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Code Signing Setup', description: 'Configure iOS code signing certificates and Android keystore', priority: 'high' },
      { name: 'App Transport Security', description: 'Configure secure network communications', priority: 'high' },
      { name: 'Secure Storage', description: 'Implement secure data storage practices', priority: 'high' },
      { name: 'API Security', description: 'Secure API communications and authentication', priority: 'medium' }
    ],
    procedures: [
      { step: 'Generate iOS certificates', command: 'fastlane match development' },
      { step: 'Create Android keystore', command: 'keytool -genkey -v -keystore my-release-key.keystore -alias my-key-alias -keyalg RSA -keysize 2048 -validity 10000' },
      { step: 'Configure network security', command: 'Add NSAppTransportSecurity to Info.plist (iOS) or network_security_config.xml (Android)' },
      { step: 'Implement secure storage', command: 'Use Keychain Services (iOS) or Android Keystore' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Certificate Pinning', description: 'Implement SSL certificate pinning', priority: 'high' },
      { name: 'Obfuscation', description: 'Code obfuscation and anti-tampering measures', priority: 'high' },
      { name: 'Runtime Security', description: 'Runtime application self-protection', priority: 'medium' },
      { name: 'Vulnerability Scanning', description: 'Regular security vulnerability assessments', priority: 'medium' }
    ],
    procedures: [
      { step: 'Implement certificate pinning', command: 'Configure TrustKit (iOS) or Network Security Config (Android)' },
      { step: 'Enable code obfuscation', command: 'Configure ProGuard/R8 (Android) or Swift obfuscation (iOS)' },
      { step: 'Add root detection', command: 'Implement jailbreak/root detection mechanisms' },
      { step: 'Run security scan', command: 'Use OWASP Mobile Security Testing Guide tools' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Architecture', description: 'Design comprehensive mobile security architecture', priority: 'high' },
      { name: 'Compliance Framework', description: 'Ensure compliance with mobile security standards', priority: 'high' },
      { name: 'Threat Modeling', description: 'Conduct mobile app threat modeling', priority: 'medium' },
      { name: 'Security Incident Response', description: 'Mobile security incident response procedures', priority: 'high' }
    ],
    procedures: [
      { step: 'Configure mobile threat defense', command: 'Implement mobile threat defense solution' },
      { step: 'Set up security monitoring', command: 'Configure mobile security monitoring and alerting' },
      { step: 'Enable advanced protection', command: 'Implement advanced anti-fraud and anti-tampering measures' },
      { step: 'Security compliance audit', command: 'Conduct regular security compliance audits' }
    ]
  }
};
